import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSandboxBankTransactionsFilters } from '../../../../hooks/useSandboxBankTransactionsFilters'
import { SearchWithFilters } from '../../../SearchWithFilters'
import { BankTransactionsFiltersPanel } from './elements/BankTransactionsFiltersPanel/BankTransactionsFiltersPanel'

export const BankTransactionsSearch = (): ReactElement => {
  const { t } = useTranslation()
  const [filters, setFilters] = useSandboxBankTransactionsFilters()

  const handleSearchChange = useCallback(
    (value: string | undefined) => {
      setFilters({ searchQuery: value })
    },
    [setFilters],
  )

  return (
    <SearchWithFilters
      searchQuery={filters.searchQuery}
      onSearchChange={handleSearchChange}
      searchPlaceholder={t('bank_transactions.toolbar.search')}
      filtersPanel={<BankTransactionsFiltersPanel />}
      filtersDropdownSize="xxl"
    />
  )
}
